import React, {Component} from "react";
import "./Inquiry.css";
import {FormattedMessage} from "react-intl";
import InquiryTable from "./InquiryTable/InquiryTable";
import InquiryTitleBar from "./InquiryTitleBar/InquiryTitleBar";
import {GOOGLE_ANALYTICS_CODE, ITEM_COUNT_PER_PAGE, RESOURCE_BASE_URL} from "../../../configuration";
import axios from "axios";
import AllCustomersTable from "../AllCustomers/AllCustomersTable/AllCustomersTable";
import ReactGA from "react-ga";

class Inquiry extends Component {

    constructor(props) {
        super(props);
        this.state = {
            items: [1, 2, 3, 4],
            inquiries: [],
            totalItemCount: 0,
            activePage: 1,
            searchData: {
                searchText: null,
                statusCodes: [],
                searchStartDate: null,
                searchEndDate: null,
                page: 0,
                size: 5
            }
        };
        this.handlePageChange = this.handlePageChange.bind(this);
        this.getAllInquiries = this.getAllInquiries.bind(this);
        this.handleSearchOnChange = this.handleSearchOnChange.bind(this);
        this.onChangeReplied = this.onChangeReplied.bind(this);
        // this.onChangeNew = this.onChangeNew.bind(this);
        // this.onChangeAnswered = this.onChangeAnswered.bind(this);
        // this.onChangeClose = this.onChangeClose.bind(this)
        this.addStatusToArray = this.addStatusToArray.bind(this);
        this.removeStatusFromArray = this.removeStatusFromArray.bind(this);
        this.setSearchStatus = this.setSearchStatus.bind(this);
        this.setSearchTimeRange = this.setSearchTimeRange.bind(this);
        this.formatDate = this.formatDate.bind(this);
        this.setSearchTimePeriod = this.setSearchTimePeriod.bind(this);
        this.setSearchText = this.setSearchText.bind(this);
        this.getFilteredInquiries = this.getFilteredInquiries.bind(this);
    }

    formatDate = (date) => {
        let today = new Date(date);


        let todayPlus = today.getDate();

        /*if (today.getDate() === 30 || today.getDate() === 31){
             todayPlus = today.getDate()+1 ;
        }else {
             todayPlus = today.getDate()+1 ;
        }*/
        // let todayPlus = today.getDate();
        let d = new Date(date),
            month = '' + (d.getMonth() + 1),

            day = '' + todayPlus,

            year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
    };

    setSearchTimePeriod = (period) => {
        let periodCode = period;
        // console.log("PERIOD ====> ", periodCode);

        let today_date = new Date();
        // console.log("TODAY DATE ====> ", today_date.getFullYear()+"-"+today_date.getUTCMonth()+"-"+today_date.getDay());
        let todayDate = new Date();
        let today = this.formatDate(today_date);

        let week = new Date(todayDate.setDate(todayDate.getDate() - 7));
        let month = new Date(todayDate.getFullYear(), new Date().getMonth(), -1);
        let year = new Date(new Date().getFullYear(), 0, -1);

        let beforeWeek = this.formatDate(week);
        let beforeMonth = this.formatDate(month);
        let beforeYear = this.formatDate(year);
        let oldestDate = this.formatDate("1920-01-01");

        let searchData = {...this.state.searchData};
        searchData.searchEndDate = today;
        if (periodCode == 1) {
            let dateBeforeToday = new Date();
            dateBeforeToday.setDate(dateBeforeToday.getDate() - 1);
            searchData.searchStartDate = this.formatDate(dateBeforeToday);
            searchData.searchEndDate = today;
        } else if (periodCode == 2) {
            searchData.searchStartDate = beforeWeek;
            searchData.searchEndDate = today;
        } else if (periodCode == 3) {
            searchData.searchStartDate = beforeMonth;
            searchData.searchEndDate = today;
        } else if (periodCode == 4) {
            searchData.searchStartDate = beforeYear;
            searchData.searchEndDate = today;
        } else if (periodCode == 6) {
            searchData.searchStartDate = oldestDate;
            searchData.searchEndDate = today;
        } else {
            searchData.searchStartDate = this.formatDate(today_date.getFullYear() - 100 + "-" + today_date.getMonth() + "-" + today_date.getDay());
            searchData.searchEndDate = this.formatDate(today_date.getFullYear() + 100 + "-" + today_date.getMonth() + "-" + today_date.getDay());
        }

        // this.setState({
        //     searchData
        // }, ()=> this.getFilteredOrders());
        this.setState({
            searchData
        }, () => this.getFilteredInquiries());
    };

    setSearchText = (event) => {

        let searchData = {...this.state.searchData};

        searchData.searchText = event.target.value;

        this.setState({
            searchData
        }, () => this.getFilteredInquiries())

    };

    setSizeAndPage = () => {

        let searchData = {...this.state.searchData};

        searchData.page = 1;
        searchData.size = 10;

        this.setState({
            searchData
        }, () => this.getFilteredInquiries())

    };

    getFilteredInquiries = () => {
        let searchData = {...this.state.searchData};
        searchData.searchStartDate = searchData.searchStartDate + "T00:00:00.000000 ";
        searchData.searchEndDate = searchData.searchEndDate + "T00:00:00.000000 ";
        searchData.page = this.state.activePage - 1;
        if (this.state.searchData.statusCodes == []) {
            searchData.statusCodes = ["NEW"];
        }

        let TestData = {

            searchText: '',
            statusCodes: ["NEW"],
            searchStartDate: "2014-01-01T00:00:00",
            searchEndDate: "2020-01-01T00:00:00",
            page: 0,
            size: 10

        };
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };
        // console.log('act22',this.state.activePage);
        // console.log('searchdata',searchData);
        axios.post(RESOURCE_BASE_URL + 'api/admin/inquiries/multi-search', searchData, axiosConfig)
            .then((res) => {
                // console.log("FILTERED INQUIRIES ==== > ", res.data);
                this.setState({
                    inquiries: res.data.inquiries.content,
                    totalItemCount: res.data.rowCount
                })
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            });
    };

    setSearchTimeRange = (name, value) => {
        // console.log("DATE VALUE RANGE =====> ", value);

        let today_date = new Date();
        // console.log("TODAY DATE ====> ", today_date.getFullYear()+"-"+today_date.getUTCMonth()+"-"+today_date.getDay());
        let today = this.formatDate(today_date);

        let years = today_date.getFullYear() - 100;


        let searchData = {...this.state.searchData};
        if (name === "from") {
            searchData.searchStartDate = value;
            if (value === null) {
                searchData.searchStartDate = this.formatDate(new Date("1920-01-01"));
            }
        } else {
            searchData.searchEndDate = value;
            if (value === null) {
                searchData.searchEndDate = today;
            }
        }

        this.setState({
            searchData
        }, () => this.getFilteredInquiries());

        // console.log("SEARCH DATAAAAAAAA ====> ", searchData);
    };


    addStatusToArray = (array1, array2) => {
        let newArray = array1.concat(array2);

        // removing duplicates
        return Array.from(new Set(newArray));
    };

    removeStatusFromArray = (array1, array2) => {
        let myArray = array1;
        myArray = myArray.filter((el) => {
            return array2.indexOf(el) < 0;
        });
        return myArray;
    };

    setSearchStatus = (event) => {
        //
        // status codes

        // replied -> 0
        // unreplied -> 1
        // new -> 2
        // closed -> 3

        let statusCode = event.target.value;
        let checked = event.target.checked;
        // console.log("STATUS CODE ===> ",event.target.value);

        let newInquiries = ["NEW"];
        let replied = ["REPLIED"];
        let closed = ["CLOSED"];
        let unreplied = ["UNREPLIED"];
        // let all = [0,1,2,3];

        let searchData = {...this.state.searchData};

        let status = [];

        if (checked) {
            if (statusCode == 0) {
                status = this.addStatusToArray(searchData.statusCodes, replied);
            } else if (statusCode == 1) {
                status = this.addStatusToArray(searchData.statusCodes, unreplied);
            } else if (statusCode == 2) {
                status = this.addStatusToArray(searchData.statusCodes, newInquiries);
            } else if (statusCode == 3) {
                status = this.addStatusToArray(searchData.statusCodes, closed);
            }
        } else {
            if (statusCode == 0) {
                status = this.removeStatusFromArray(searchData.statusCodes, replied);
            } else if (statusCode == 1) {
                status = this.removeStatusFromArray(searchData.statusCodes, unreplied);
            } else if (statusCode == 2) {
                status = this.removeStatusFromArray(searchData.statusCodes, newInquiries);
            } else if (statusCode == 3) {
                status = this.removeStatusFromArray(searchData.statusCodes, closed);
            }
        }

        // console.log("NEW STATUS CODES ===== > ", status);
        searchData.statusCodes = status;

        this.setState({
            searchData
        }, () => this.getFilteredInquiries());

    };

    handleSearchOnChange = (event) => {
        // console.log("Searching....");
        if (event.target.value === "") {
            this.getAllInquiries(0, ITEM_COUNT_PER_PAGE)
        } else {

            let resourceUrl = RESOURCE_BASE_URL + 'api/admin/inquiries/search/' +
                event.target.value + '?offset=' + 0 + '&limit=' + ITEM_COUNT_PER_PAGE;

            axios.get(resourceUrl)
                .then((res) => {
                    this.setState({
                        inquiries: res.data.inquiries,
                        totalItemCount: res.data.rowCount
                    });
                    // console.log(res.data);
                })
                .catch((err) => {
                    console.log("[API] ERROR: ", err);
                });
        }
    };

    onChangeReplied = (event) => {
        // console.log("Searching....");
        if (event.target.checked === false) {
            this.getAllInquiries(0, ITEM_COUNT_PER_PAGE)
        } else {

            let resourceUrl = RESOURCE_BASE_URL + 'api/admin/inquiries/unreplied' +
                '?offset=' + 0 + '&limit=' + ITEM_COUNT_PER_PAGE;

            axios.get(resourceUrl)
                .then((res) => {
                    this.setState({
                        inquiries: res.data.inquiries,
                        totalItemCount: res.data.rowCount
                    });
                    // console.log(res.data);
                })
                .catch((err) => {
                    console.log("[API] ERROR: ", err);
                });
        }
    };


    handlePageChange = (pageNumber) => {
        // console.log(`active page is ${pageNumber}`);

        this.setState({activePage: pageNumber}, () => this.getFilteredInquiries());

        let offset = (pageNumber - 1) * ITEM_COUNT_PER_PAGE;
        // this.getAllInquiries(pageNumber - 1, ITEM_COUNT_PER_PAGE);
        let searchData = {...this.state.searchData};

        // this.getFilteredInquiries();
    };

    componentDidMount() {

        let searchData = {...this.state.searchData};

        let todayDate = new Date();

        let today = this.formatDate(todayDate);
        searchData.statusCodes = ["NEW"];
        searchData.searchEndDate = today;
        let days = todayDate.getDate() - 1;
        todayDate.setDate(days);
        searchData.searchStartDate = this.formatDate(todayDate);

        this.setState({
            searchData
        }, () => this.getFilteredInquiries());


        // this.getAllInquiries(0, ITEM_COUNT_PER_PAGE);
    }

    getAllInquiries = (offset, limit) => {
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'Access-Control-Allow-Origin': '*'
            }
        };
        axios.get(RESOURCE_BASE_URL + 'api/users/inquiries?offset=' + offset + '&limit=' + limit, axiosConfig)
            .then((res) => {
                this.setState({
                    inquiries: res.data.inquiries.content,
                    totalItemCount: res.data.rowCount
                });
                // console.log(res.data);
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            });
    };

    render() {
        ReactGA.initialize(GOOGLE_ANALYTICS_CODE);
        ReactGA.pageview(window.location.pathname + window.location.search);

        return (
            <div className="admin-inquiry-div margin-top-inquiry admin-tables-wrapper">

                <InquiryTitleBar
                    handleSearchOnChange={this.handleSearchOnChange}
                    onChangeReplied={this.onChangeReplied}
                    setSearchStatus={this.setSearchStatus}
                    setSearchText={this.setSearchText}

                />
                <div className="">
                    <InquiryTable handlePageChange={this.handlePageChange}
                                  totalItemCount={this.state.totalItemCount}
                                  activePage={this.state.activePage}
                                  inquiries={this.state.inquiries}
                                  setSearchStatus={this.setSearchStatus}
                                  setSearchTimeRange={this.setSearchTimeRange}
                                  setSearchTimePeriod={this.setSearchTimePeriod}
                                  getAll={this.getFilteredInquiries}

                    />
                </div>
            </div>
        )
    }
}

export default Inquiry;



// WEBPACK FOOTER //
// ./src/components/Admin/Inquiry/Inquiry.js